import "./index.css";
import React from "react";
import { render } from "react-dom";
import { App } from "./App";

// 2026-10-20: vínculo orden ↔ cuestionario. Cuando /pedido guarda el pedido
// (Edge Function submit-order) se recuerda el id de la orden en localStorage
// 'noor_order_id'; la página /gracias lo agrega a los enlaces de los cuestionarios.
// Solo observa la respuesta (clon); no cambia nada del pedido.
try {
  const origFetch = window.fetch.bind(window);
  window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
    const p = origFetch(input, init);
    try {
      const u = typeof input === 'string' ? input : input instanceof URL ? input.href : (input as Request).url;
      if (u.indexOf('/functions/v1/submit-order') !== -1) {
        p.then(r => r.clone().json()).then(j => {
          if (j && j.ok && typeof j.id === 'string') {
            try {
              window.localStorage.setItem('noor_order_id', j.id);
            } catch {/* sin almacenamiento */}
          }
        }).catch(() => {});
      }
    } catch {/* nunca afectar el pedido */}
    return p;
  };
} catch {/* sin fetch */}
render(<App data-id="element-493" data-mp="15mc7xuitbks1" />, document.getElementById("root"));